//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
export default {
  props: {
    diffUserList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Avatar: Avatar
  },
  data: function data() {
    return {};
  },
  methods: {
    close: function close() {
      this.$emit('input', false);
      this.$emit('close');
    }
  }
};